export default "__VITE_ASSET__BuhvfNLb__"